<template>
  <div class="ui-recent" :class="version == 'horiz'?'h-17':'h-19'">
    <div id="ui-mic" v-if="micStatus"></div>
    <!-- <NoneData tips='加载中...' :version='version' class="flex" v-else></NoneData> -->
  </div>
</template>

<script>
import fitChartSize from "@/common/js/echartFontSize.js";
import { formateDate } from "@/utils/date.js";
import NoneData from '@/components/NoneData.vue'
export default {
  props: {
    micInfo: {
      type: Object,
      default: {}
    },
    micStatus:{
        type:Boolean,
        default:false
    },
    isOnlineFlag:{
      type:Boolean,
      default:false
    },
    version: {
      type: String
    }
  }, 
  data() {
    return {
      dataX:[],
      dataY:[]
    };
  },
  components:{
      NoneData
  },
  watch: {
    micInfo(val) { 
      let that = this; 
      that.dataX = [];
      that.dataY = [];
      if(val){ 
        that.dataX = val.collectTimeDetailList&& val.collectTimeDetailList.length>0?val.collectTimeDetailList:[];
        that.dataY = val.resultList&& val.resultList.length>0?val.resultList:[];  
        // val.microBar.map(item=>{  
        //   let time = item.columnName.split(' ')[1]; 
        //   this.dataX.push(time.substring(0,5))
        //   this.dataY.push(Math.round(item.value))
        // }) 
      }   
    },
    micStatus(val){
      setTimeout(()=>{
        this.initWaterEcharts();
      },100) 
    }
  }, 
  methods: { 
    // formatDate(date) {
    //   console.log(date)
    //   var date = new Date(date);
    //   var YY = date.getFullYear() + '-';
    //   var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    //   var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
    //   var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    //   var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
    //   var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
    //   return YY + MM + DD +" "+hh + mm; 
    // },
    //用水趋势
    initWaterEcharts() { 
      let that = this;
      let myChart = echarts.init(document.getElementById("ui-mic"), null, {
        renderer: "svg"
      });  
      let datasX;
      let datasY;
      if(that.dataX)datasX = JSON.parse(JSON.stringify(that.dataX));
      if(that.dataY)datasY = JSON.parse(JSON.stringify(that.dataY));
      let option;  
      if((datasX && datasX.length) || (datasY && datasY.length)){
        option = {
          legend: {
            selectedMode: false
          },
          grid: {
            top: "4%",
            left: "1%",
            bottom: "5%",
            right: "1%",
            containLabel: true
          },
          xAxis: [
            {
              type: "category",
              boundaryGap: false,
              axisLine: {
                lineStyle: {
                  color: "#677588"
                },
                fontSize: fitChartSize(12)
              },
              axisTick: {
                show: false
              },
              axisLabel: {
                color: "#677588",
                fontSize: fitChartSize(12),
                // rotate: 45,
                showMinLabel: true,
                showMaxLabel: true,
                formatter (val, i) { 
                  if (val && ( i === 0 ||  i === datasX.length - 1)) { 
                    let year = new Date().getFullYear();
                    let timeStr;
                    let timeArr = formateDate(Number(val), 'yyyy-MM-dd').split("-"); 
                    if(year == timeArr[0]){
                      timeStr = timeArr[1] + "-" + timeArr[2];
                    } else {
                      timeStr = timeArr[0] + "\n" + timeArr[1] + "-" + timeArr[2]
                    }
                    return timeStr; 
                  }
                  return '' 
                },
                // interval: Math.ceil(datasX.length / 2)
              },
              // data: datasX
            }
          ],
          yAxis: {
            type: "value",
            max:Math.round(that.micInfo.microThreshold),
            nameTextStyle: {
              color: "#677588",
              fontSize: fitChartSize(12)
            },
            axisLine: {
              show: true,
              lineStyle: {
                width: 1, //这里是为了突出显示加上的
                color: "#677588"
              },
              fontSize: fitChartSize(12)
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show:false,
              fontSize: fitChartSize(12),
              color: "#677588"
            }, 
            splitLine: {
              show: false
            }
          },
          series: [
            {
              type: "line", 
              smooth: true,
              symbol: "circle",
              symbolSize: 1,
              smooth: true,
              lineStyle: {
                color: "#E6752A", //折线的颜色,
                width: 1
              }, 
              markLine:{
                  symbol:'none',
                  label:{
                      position:'end'
                  },
                  data:[
                      // {
                      //     yAxis:Math.round(that.micInfo.microThreshold),
                      //     label:{  
                      //       show:true,
                      //       color:'#fff',  
                      //       fontSize: fitChartSize(12),
                      //       formatter: function(data){   
                      //         return '预警值'
                      //       }, 
                      //     },
                      //     lineStyle:{
                      //         type:"solid",
                      //         color:"#FEDA4A"
                      //     }
                      // }, 
                      {
                          yAxis:Math.round(that.micInfo.microWarnUpper),
                          label:{ 
                              show:false
                          },
                          lineStyle:{
                              type:"solid",
                              color:"#3694F9"
                          }
                      }, 
                  ], 
              },
              data: datasY
            }
          ]
        };
      } else {
        option = { 
          title: {
              text: this.isOnlineFlag?"暂无数据":'设备已离线',
              x: "center",
              y: "center",
              textStyle: {
              color: "#ccc",
              fontWeight: "normal",
              fill: "#9d9d9d",
              fontWeight: "bold",
              text: this.isOnlineFlag?"暂无数据":'设备已离线',
              fontFamily: "Microsoft YaHei",
              fontSize: fitChartSize(18) 
              }
          }
        };
      } 
      myChart.clear();
      myChart.setOption(option, true);
      window.addEventListener("resize", that.changeScreen(myChart));
    },
    changeScreen(myChart){
      myChart.resize();
    }
  },
  destroyed(){   
     window.removeEventListener("resize",this.changeScreen)
  }
};
</script>

<style lang="scss" scoped>
.h-19 {
  height: 19.3rem;
}
.h-17 {
  height: 15rem;
  height: 100%;
} 
#ui-mic {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/MicLine.vue